import React from 'react'
import "./Layout.css"
import LeftDrawerChatPage from '../../component/LeftDrawerComponent/LeftDrawerChatPage'
import { useNavigate } from 'react-router-dom'
import MyContext from '../../Context/AppContext'
import { Outlet } from 'react-router-dom';
import Header from '../../component/header/Header'
import CheckUsageModal from '../../component/checkUsageModal/CheckUsageModal'
import SupportEmail from '../../component/SupportEmail/SupportEmail'
import UpgradeContactModal from '../../component/UpgradeContactModal/UpgradeContactModal'


const Layout = () => {
  const { openDrawer, setOpenDrawer, checkAuthStatus } = React.useContext(MyContext);
  const navigate = useNavigate();
  const recentChatHistory = [];

  const navigateTo = (props) => {
    navigate(props);
  }

  const isLoggedIn = checkAuthStatus();

  return (
    <>
      {
        isLoggedIn &&
        <div className='maindiv_chatpage' >
          <div className={openDrawer ? 'leftside_chatpage' : 'leftside_chatpage displayNone'}>
            <LeftDrawerChatPage navigateTo={navigateTo} openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} recentChatHistory={recentChatHistory} />
          </div>
          <div className="rightside_chatpage">
            <Header />
            <Outlet />
          </div>
          <CheckUsageModal />
          <SupportEmail />
          <UpgradeContactModal />
        </div>
      }
    </>
  )
}

export default Layout
